/**
 * gameId → GameUi, mirroring the engine's module registry on the server side.
 * A game without a UI yet is shown in the lobby as `soon`, and this map simply
 * has no entry for it.
 */
import type { GameId } from '@cards/shared'
import type { GameUi } from './types'
import { fiveHundredUi } from './five-hundred/ui'
import { pitchUi } from './pitch/ui'
import { beloteUi } from './belote/ui'
import { belotUi } from './belot/ui'
import { bridgeUi } from './bridge/ui'

const registry = new Map<GameId, GameUi>([
  ['five-hundred', fiveHundredUi],
  ['pitch', pitchUi],
  ['belote', beloteUi],
  ['belot', belotUi],
  ['bridge', bridgeUi],
])

/** An unknown id falls back to 500's UI rather than
 *  throwing: a snapshot for a game we cannot draw is still better rendered as a
 *  generic table than as a crash. */
export function getGameUi(id: GameId): GameUi {
  return registry.get(id) ?? fiveHundredUi
}

export function hasGameUi(id: GameId): boolean {
  return registry.has(id)
}

export const GAME_TABS: readonly { id: GameId; name: string; soon: boolean }[] = [
  { id: 'five-hundred', name: '500', soon: false },
  { id: 'belote', name: 'Belote', soon: false },
  { id: 'belot', name: 'Bulgarian', soon: false },
  { id: 'pitch', name: 'Pitch', soon: false },
  { id: 'bridge', name: 'Bridge', soon: false },
]

export type { GameUi } from './types'
